export default __webpack_public_path__ + "static/media/filmLogo.d7f7e81d.svg";